import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { Platform } from '@angular/cdk/platform';
/***** Const *****/
import { pcPath, mobilePath } from '../app-path.const';
/**** JWT ***/
import { JwtHelperService } from '@auth0/angular-jwt';
const jwtHelper = new JwtHelperService();
/***** Rxjs *****/
import { take } from 'rxjs/operators';
/***** Servcies *****/
import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { GlobalService } from './global.service';
import { LanguageService } from './language.service';
import { SocketioService } from './socketio.service';
import { StorageService } from './storage.service';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class StartupService {

  /***** 安裝至桌面 *****/
  private promptEvent: any;

  constructor(
    private injector: Injector,
    private updates: SwUpdate,
    private platform: Platform,
    /***** Services *****/
    private apiService: ApiService,
    private globalService: GlobalService,
    private languageService: LanguageService,
    // private socketioService: SocketioService,
    private storageService: StorageService,
    private utilsService: UtilsService,
  ) { }

  /***** APP初始化前做的事情。EX. 呼叫 API 取得設定檔 *****/
  initializeApp(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      console.log('===== Initial APP =====');

      /* 連接socket */
      // this.socketioService.connectSocket();

      /*** 語言初始化 ***/
      this.languageService.setInitState();

      /*** 設定網頁資訊 ***/
      this.setSiteInfo();

      /*** 設置登入狀態(檢查Token) ***/
      this.setLoginStatus();

      /*** 設定初始路徑 ***/
      this.setDeviceInitRoute();

      /* 抓取各種選項資料 */
      resolve(true);

      // /*** 檢查使用者 ***/
      // this.userService.checkUser().subscribe(res => {
      //   if (res) {
      //     setInterval(() => {
      //       this.checkStatus();
      //     }, 1000 * 60 * 5); // check current status every 5 min
      //     this.login();
      //   } else {
      //     this.logout();
      //   }
      //   resolve(true);
      // });
    });
  }
  
  private setSiteInfo(): void {
    this.globalService.setSiteInfo({
      site_uniform_no: '72514020', // 公司統編
      site_full_name: '革雲科技資訊社', // 公司全稱
      site_short_name: '革雲科技', // 公司簡稱
      site_logo: 'assets/imgs/logo/logo.png', // 公司logo
      // site_tab: './assets/imgs/tab/icon-96x96.png'
    });
  }
  private setLoginStatus(): void {
    const authToken = this.storageService.getToken();
    if (authToken) {
      const authService: AuthService = this.injector.get(AuthService);
      if (!this.isTokenExpired(authToken)) { /* Token 有效 */
        console.log('Token is effective');
        authService.setLoginStatus(true);
        authService.getUserInfoFromServer().pipe(take(1)).subscribe();
      } else { /* Token 過期 */
        console.log('Token is expired');
        authService.setLoginStatus(false);
      }
    }
  }
  private setDeviceInitRoute(): void {
    const router = this.injector.get(Router);
    if (this.checkDevice() === 'pc') {
      router.navigate([`${pcPath.perfix}`]);
    } else if (this.checkDevice() === 'mb') {
      router.navigate([`${mobilePath.perfix}`]);
    }

    // if (this.checkDevice() === 'PC') {
    //   router.navigate([`${pcPath.perfix}/system/${pcPath.menu}`]);
    // } else {
    //   router.navigate([`${mobilePath.perfix}/system/${mobilePath.menu}`]);
    // }
    // if (this.checkDevice() === 'PC') {
    //   router.navigate([`${pcPath.perfix}/${pcPath.login}`]);
    // } else {
    //   router.navigate([`${mobilePath.perfix}/${mobilePath.login}`]);
    // }
  }
  // private checkStatus() {
  //   if (this.utilsService.isTokenExpired()) {   // if token expired
  //     this.logout();
  //     console.log('logout due to token expired');
  //   }
  // }


  /***** Functions *****/
  private isTokenExpired(token: string): boolean {
    return jwtHelper.isTokenExpired(token);
  }
  private checkDevice(): 'pc' | 'mb' {
    const mobileDevice = ['Android', 'webOS', 'iPhone', 'iPad', 'iPod', 'BlackBerry', 'Windows Phone'];
    // console.log(navigator.userAgent);
    let device: 'pc' | 'mb' = 'pc';
    for (let i = 0; i < mobileDevice.length; i++) {
      if (navigator.userAgent.match(mobileDevice[i])) {
        device = 'mb';
      }
    }
    return device;
  }

}
